// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2AfKX","loaderOuter":"PageOverlayLoader_loaderOuter__154MV"};